<app-spinner></app-spinner>
<div>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title_tag }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="emailTemplateForm" novalidate>
      <div class="row mt-3">
        <div class="col-4">
          <label for="templateName" class="text-black-1">Template Name</label>
        </div>
        <div class="input-group col-8">
          <input
            id="templateName"
            class="form-control rb-input"
            placeholder="Please enter Email template name."
            formControlName="templateName"
            name="templateName"
            type="text"
          />
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.templateName.touched || submitted) && formControl.templateName.errors"
          >
            <label for="templateName" class="text-danger" *ngIf="formControl.templateName.errors.required"
              >*Template Name is required.</label
            >
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="subject" class="text-black-1">Subject</label>
        </div>
        <div class="input-group col-8">
          <input
            id="subject"
            class="form-control rb-input"
            placeholder="Please enter Email Subject."
            formControlName="subject"
            name="subject"
            type="text"
          />
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.subject.touched || submitted) && formControl.subject.errors"
          >
            <label for="subject" class="text-danger" *ngIf="formControl.subject.errors.required"
              >*Subject is required.</label
            >
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="body" class="text-black-1">Email Body</label>
        </div>
        <div class="input-group col-8">
          <!--          <textarea-->
          <!--            id="body"-->
          <!--            class="form-control rb-input"-->
          <!--            placeholder="Add Email template description."-->
          <!--            formControlName="body"-->
          <!--            name="body"-->
          <!--            type="text"-->
          <!--            mwlTextInputAutocomplete-->
          <!--            [findChoices]="findChoices"-->
          <!--            [getChoiceLabel]="getChoiceLabel"-->
          <!--            [menuComponent]="menuComponent"-->
          <!--            [triggerCharacter]="triggerCharacter"-->
          <!--          >-->
          <!--          </textarea>-->
          <quill-editor formControlName="body" [styles]="{ height: '200px' }" [modules]="quillConfig"></quill-editor>
          <div class="col-12 error-mssg" *ngIf="(formControl.body.touched || submitted) && formControl.body.errors">
            <label for="body" class="text-danger" *ngIf="formControl.body.errors.required">*Body is required.</label>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)" ngbAutoFocus>Cancel</button>
    <button class="btn-save ml-4 w-100" *ngIf="!isLoading" (click)="save()">Submit</button>
    <button class="btn-save ml-4 w-100" disabled *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin" style="font-size: 16px"></i>
    </button>
  </div>
</div>
